import axios from 'axios'
import React, { useState, useRef, useEffect } from 'react'
import { Card, Button, Divider, Row, Input, Space, Typography, Pagination, Tooltip } from 'antd'
import {
  ArrowLeftOutlined,
  ArrowRightOutlined,
  AudioOutlined,
  RedoOutlined,
  AudioMutedOutlined,
  EditOutlined,
  StopFilled
} from '@ant-design/icons'
import Countdown from './Countdown'
import './Audio.less'
import Footer from '@/layouts/footer'

const { Text } = Typography
const mimeType = 'audio/webm'
const OPENAI_API_KEY = process.env.OPENAI_API_KEY
const model = 'wishper-1'

const Audio = (props) => {
  const [permission, setPermission] = useState(false)
  const mediaRecorder = useRef(null)
  const [recordingStatus, setRecordingStatus] = useState('inactive')
  const [stream, setStream] = useState(null)
  const [audioChunks, setAudioChunks] = useState([])
  const [isRunning, setIsRunning] = useState(false)
  const [elapsedTime, setElapsedTime] = useState(0)
  const [showCountdown, setShowCountdown] = useState(false)

  useEffect(() => {
    getMicrophonePermission()
  }, [])

  useEffect(() => {
    let intervalId

    if (isRunning) {
      const startTime = Date.now() - elapsedTime
      intervalId = setInterval(() => {
        const currentTime = Date.now()
        const newElapsedTime = currentTime - startTime
        if (newElapsedTime >= 60 * 1000) {
          stopRecording()
          setIsRunning(false)
          setElapsedTime(60 * 1000)
          clearInterval(intervalId)
        } else {
          setElapsedTime(newElapsedTime)
        }
      }, 10)
    } else {
      clearInterval(intervalId)
    }

    return () => {
      clearInterval(intervalId)
    }
  }, [isRunning, elapsedTime])

  const handleStartStop = () => {
    setIsRunning((prevIsRunning) => !prevIsRunning)
  }

  const handleReset = () => {
    setIsRunning(false)
    setElapsedTime(0)
    props.setAudio(null)
  }

  const minutes = Math.floor(elapsedTime / 60000)
  const seconds = ((elapsedTime % 60000) / 1000).toFixed(0)

  const startCountdown = () => {
    setShowCountdown(true)
    setTimeout(() => {
      startRecording()
    }, 3000)
  }

  const handleCountdownComplete = () => {
    setShowCountdown(false)
  }

  const getMicrophonePermission = async () => {
    if ('MediaRecorder' in window) {
      try {
        const streamData = await navigator.mediaDevices.getUserMedia({
          audio: true,
          video: false
        })
        setPermission(true)
        setStream(streamData)
      } catch (err) {
        alert(err.message)
      }
    } else {
      alert('The MediaRecorder API is not supported in your browser.')
    }
  }

  const startRecording = async () => {
    handleReset()
    handleStartStop()
    setRecordingStatus('recording')
    const media = new MediaRecorder(stream, { type: mimeType })
    mediaRecorder.current = media
    mediaRecorder.current.start()
    let localAudioChunks = []
    mediaRecorder.current.ondataavailable = (event) => {
      if (typeof event.data === 'undefined') return
      if (event.data.size === 0) return
      localAudioChunks.push(event.data)
    }
    setAudioChunks(localAudioChunks)
  }
  // const updateAudio = (index, value) => {
  //   const newArray = props.audio.slice()
  //   newArray[index] = value
  //   props.setAudio(newArray)
  // }

  const stopRecording = () => {
    setRecordingStatus('inactive')
    mediaRecorder.current.stop()
    mediaRecorder.current.onstop = () => {
      const audioBlob = new Blob(audioChunks, { type: mimeType })
      const audioUrl = URL.createObjectURL(audioBlob)
      // updateAudio(props.quesNum - 1, audioBlob)
      props.setAudio(audioBlob)

      const questionKey = `audioUrls_question_${props.selcQues}`
      const existingAudioUrlsJSON = localStorage.getItem(questionKey)
      const existingAudioUrls = existingAudioUrlsJSON ? JSON.parse(existingAudioUrlsJSON) : []

      if (existingAudioUrls.length > 0) {
        existingAudioUrls[0] = audioUrl
      } else {
        existingAudioUrls.push(audioUrl)
      }
      // const newAudioUrls = [...existingAudioUrls, audioUrl];

      localStorage.setItem(questionKey, JSON.stringify(existingAudioUrls))
      // console.log('Audio Blob:', audioBlob)
      // console.log('Audio URL:', audioUrl)
      setAudioChunks([])
    }
    handleStartStop()
  }

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        {showCountdown && <Countdown onCountdownComplete={handleCountdownComplete} />}
        <div className="questions-card">
          <Card align="left">
            <Space direction="vertical" justify="start" align={'middle'} style={{ width: '100%' }}>
              <Row justify="space-between">
                <Text mark>Question </Text>
                {/* <Text> {props.quesNum}/5</Text> */}
              </Row>
              <Row justify="start">
                <Text className="question">{props.selcQues}</Text>
              </Row>
            </Space>
            <Divider />
            <Row justify="space-between" align={'middle'}>
              <Space>
                {!permission ? (
                  <Tooltip title="Please allow microphone access" placement="bottom">
                    <Button
                      type="primary"
                      icon={<AudioOutlined />}
                      size="large"
                      style={{ paddingRight: 30, paddingLeft: 30 }}
                      className="btn_text"
                      onClick={getMicrophonePermission}
                    >
                      Get Permission
                    </Button>
                  </Tooltip>
                ) : null}
                {permission && recordingStatus === 'inactive' ? (
                  <Button
                    type="primary"
                    icon={props.audio ? <RedoOutlined /> : <AudioOutlined />}
                    size="large"
                    style={{ paddingRight: 30, paddingLeft: 30 }}
                    className="btn_text"
                    onClick={() => {
                      startCountdown()
                    }}
                  >
                    {props.audio ? 'Retake' : 'Answer'}
                  </Button>
                ) : null}
                {recordingStatus === 'recording' ? (
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      flexDirection: 'row',
                      backgroundColor: 'black',
                      padding: 15,
                      paddingRight: 25,
                      color: 'white',
                      borderRadius: 5,
                      cursor: 'pointer'
                    }}
                    onClick={stopRecording}
                  >
                    <Button
                      type="primary"
                      size="small"
                      style={{
                        color: 'red',
                        backgroundColor: 'red',
                        width: 25,
                        height: 25,
                        marginInline: 10
                      }}
                    >
                      .
                    </Button>
                    <div>
                      {minutes.toString().padStart(2, '0')}:{seconds.toString().padStart(2, '0')}
                    </div>
                    {/* <Recorder /> */}
                  </div>
                ) : null}
              </Space>
              <Space>
                {/* {props.quesNum > 1 && (
                <Button
                type="secondary"
                icon={<ArrowLeftOutlined />}
                size="large"
                style={{ fontSize: 20 }}
                  onClick={() => handleDec()}
                  />
                )} */}
                <Tooltip
                  title={
                    props.audio
                      ? null
                      : recordingStatus === 'recording'
                      ? 'Please stop recording'
                      : 'Please record your Answer'
                  }
                  placement="top"
                >
                  <Button
                    type="secondary"
                    disabled={props.audio ? false : true}
                    icon={<ArrowRightOutlined />}
                    size="large"
                    style={{ fontSize: 20 }}
                    onClick={() => props.sendAudio()}
                  />
                </Tooltip>
              </Space>
            </Row>
          </Card>
          <Row align="center" style={{ padding: 10 }}>
            <p style={{ color: 'gray', fontSize: 20 }}>
              * Keep your answers to less than <span style={{ textDecoration: 'underline' }}>1 minutes</span>.
            </p>
          </Row>
        </div>
      </div>
      <Footer />
    </>
  )
}

export default Audio
